/** toast: automatic create / update / delete confirmations (Arabic is a draft for native review). */
const en = {
  "created": "{thing} created",
  "saved": "{thing} saved",
  "deleted": "{thing} deleted",
  "n_campaign": "Campaign",
  "n_playlist": "Playlist",
  "n_app": "App",
  "n_content": "Content",
  "n_folder": "Folder",
  "n_group": "Player group",
  "n_player": "Player",
  "n_interaction": "Interaction",
  "n_layout": "Layout",
  "n_alert": "Alert",
  "n_attribute": "Custom attribute",
  "n_customApp": "App",
  "n_dataFeed": "Data feed",
  "n_region": "Region",
  "n_report": "Report",
  "moved": "Moved",
  "tagsSaved": "Tags saved",
  "attributesSaved": "Attributes saved",
  "restrictionSaved": "Restriction saved",
  "orderSaved": "Order saved",
  "paired": "Player paired",
  "unpaired": "Player unpaired",
  "settingsSaved": "Changes saved",
  "published": "Published",
  "unpublished": "Unpublished",
  "versionCurrent": "Version made current",
  "approved": "Update approved",
  "rejected": "Update rejected",
  "syncStarted": "Sync started",
  "reportStarted": "Report started",
  "acknowledged": "Acknowledged",
  "inviteSent": "Invitation sent",
  "inviteRevoked": "Invitation revoked",
  "roleChanged": "Role changed",
  "memberRemoved": "Member removed",
  "passwordChanged": "Password changed",
  "signedOutDevice": "Signed out of that device",
  "signedOutOthers": "Signed out everywhere else",
  "dismiss": "Dismiss"
};
const ar: typeof en = {
  "created": "تم إنشاء {thing}",
  "saved": "تم حفظ {thing}",
  "deleted": "تم حذف {thing}",
  "n_campaign": "الحملة",
  "n_playlist": "قائمة التشغيل",
  "n_app": "التطبيق",
  "n_content": "المحتوى",
  "n_folder": "المجلد",
  "n_group": "مجموعة المشغلات",
  "n_player": "المشغل",
  "n_interaction": "التفاعل",
  "n_layout": "التخطيط",
  "n_alert": "التنبيه",
  "n_attribute": "السمة المخصصة",
  "n_customApp": "التطبيق",
  "n_dataFeed": "مصدر البيانات",
  "n_region": "المنطقة",
  "n_report": "التقرير",
  "moved": "تم النقل",
  "tagsSaved": "تم حفظ الوسوم",
  "attributesSaved": "تم حفظ السمات",
  "restrictionSaved": "تم حفظ القيد",
  "orderSaved": "تم حفظ الترتيب",
  "paired": "تم إقران المشغل",
  "unpaired": "تم إلغاء إقران المشغل",
  "settingsSaved": "تم حفظ التغييرات",
  "published": "تم النشر",
  "unpublished": "تم إلغاء النشر",
  "versionCurrent": "أصبح الإصدار حاليًا",
  "approved": "تمت الموافقة على التحديث",
  "rejected": "تم رفض التحديث",
  "syncStarted": "بدأت المزامنة",
  "reportStarted": "بدأ إعداد التقرير",
  "acknowledged": "تم الإقرار",
  "inviteSent": "تم إرسال الدعوة",
  "inviteRevoked": "تم إلغاء الدعوة",
  "roleChanged": "تم تغيير الدور",
  "memberRemoved": "تمت إزالة العضو",
  "passwordChanged": "تم تغيير كلمة المرور",
  "signedOutDevice": "تم تسجيل الخروج من ذلك الجهاز",
  "signedOutOthers": "تم تسجيل الخروج من الأجهزة الأخرى",
  "dismiss": "إغلاق"
};
export default { en, ar };
